<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import axios from 'axios';
import { ElMessage, ElMessageBox } from 'element-plus'
import { Loading } from '@element-plus/icons-vue'

// 定义响应式数据
const dataList = ref([]);
const currentPage = ref(1);
const totalPages = ref(1);
const itemsPerPage = ref(25);
const totalItems = ref(1);
const searchQuery = ref(''); // 让 searchQuery 默认是字符串
const sortField = ref('runTime'); // 当前排序字段
const sortOrder = ref('-1'); // 排序顺序，'asc' 或 'desc'
// 过滤时间
const publishTimeRange = ref([]);
const fetchTimeRange = ref([]);
// 默认展开
const isSidebarOpen = ref(true);
// 预设每页数量选项
const perPageOptions = [25, 50, 100, 500];

const processing = ref(false)

// Mock 数据（当 API 请求失败时使用）
const mockData = [
    { id: 1, title: "重要新闻 A", summary: "摘要内容 A", publish_time: "2024-04-01", fetch_time: "2024-04-02", importance: "高", source: "来源 A", url: "https://example.com/news/1" },
    { id: 2, title: "普通新闻 B", summary: "摘要内容 B", publish_time: "2024-04-01", fetch_time: "2024-04-02", importance: "中", source: "来源 B", url: "https://example.com/news/2" },
    { id: 3, title: "一般新闻 C", summary: "摘要内容 C", publish_time: "2024-04-01", fetch_time: "2024-04-02", importance: "低", source: "来源 C", url: "https://example.com/news/3" },
    { id: 4, title: "重要新闻 D", summary: "摘要内容 D", publish_time: "2024-04-01", fetch_time: "2024-04-02", importance: "高", source: "来源 D", url: "https://example.com/news/4" },
    { id: 5, title: "普通新闻 E", summary: "摘要内容 E", publish_time: "2024-04-01", fetch_time: "2024-04-02", importance: "中", source: "来源 E", url: "https://example.com/news/5" }
];
import { useRouter } from "vue-router";

const router = useRouter();

// const logout = () => {
//     // 弹出确认框，询问是否退出
//     const confirmLogout = window.confirm("是否确认退出系统？");
//     if (confirmLogout) {
//         localStorage.removeItem("isLoggedIn"); // 清除登录状态
//         router.push("/login"); // 跳转到登录页
//     }
// };

const toggleSidebar = () => {
    isSidebarOpen.value = !isSidebarOpen.value;
};

// 获取数据的函数
const fetchData = async () => {
    try {
        console.log(process.env.VUE_APP_BASE_URL)
        const params = {
            publish_start: publishTimeRange.value?.[0] || null,
            publish_end: publishTimeRange.value?.[1] || null,
            fetch_start: fetchTimeRange.value?.[0] || null,
            fetch_end: fetchTimeRange.value?.[1] || null,
        };
        var url = `${process.env.VUE_APP_BASE_URL}/api/database/all?page=${currentPage.value}&pagesize=${itemsPerPage.value}`;
        var condition = {}
        if (searchQuery.value) {
            condition['title'] = { "$regex": searchQuery.value, "$options": "i" }
        }
        if (publishTimeRange.value && publishTimeRange.value[0]) {
            condition['publishTime'] = { "$gte": publishTimeRange.value[0], "$lte": publishTimeRange.value[1] }
        }
        if (fetchTimeRange.value && fetchTimeRange.value[0]) {
            condition['runTime'] = { "$gte": fetchTimeRange.value[0], "$lte": fetchTimeRange.value[1] }
        }
        if (sortField.value) {
            url += `&sortby=${sortField.value}`
        }
        if (sortOrder.value) {
            url += `&crease=${sortOrder.value}`
        }
        var condition_str = JSON.stringify(condition)
        url += `&condition=${condition_str}`

        // alert(url)
        const response = await axios.get(url);
        dataList.value = response.data.data;
        console.log("fetchData OK.")
        // 总数量
        totalItems.value = response.data.total_count
        // 页数
        totalPages.value = Math.ceil(response.data.total_count / itemsPerPage.value);
    } catch (error) {
        console.error('数据获取失败，使用 Mock 数据:', error);
        dataList.value = mockData; // 使用 Mock 数据
        totalPages.value = 1; // 只有一页
    }
};

// **监听搜索框变化，动态过滤数据**
watch(searchQuery, (newQuery) => {
    fetchData(newQuery.trim()); // 重新请求 API
});

// 切换每页数据条数
const updateItemsPerPage = () => {
    currentPage.value = 1; // 切换时重置到第一页
    fetchData();
};

// 处理翻页
const goToPage = (page, pagesize) => {
    if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
        fetchData();
    }
};

// 处理排序
const sortData = (field) => {
    if (sortField.value === field) {
        // 如果当前已经在此字段排序，切换排序顺序
        sortOrder.value = sortOrder.value === '1' ? '-1' : '1';
    } else {
        // 否则默认按升序排序
        sortField.value = field;
        sortOrder.value = '1';
    }
    fetchData()
};

// 返回排序标记（▲/▼）
const getSortIcon = (field) => {
    if (sortField.value === field) {
        return sortOrder.value === '1' ? '▲' : '▼';
    }
    return '';
};

// 计算属性：搜索 & 排序数据
const filteredAndSortedData = computed(() => {
    let filteredData = dataList.value;
    // // 搜索过滤（按标题或摘要）
    // if (searchQuery.value) {
    //     // alert(searchQuery.value)
    //     // 防止 searchQuery 为空时报错
    //     const query = searchQuery.value.trim().toLowerCase(); // 确保不会报错
    //     filteredData = filteredData.filter(item =>
    //         item.title.toLowerCase().includes(query) ||
    //         item.abstract.toLowerCase().includes(query)
    //     );
    // }

    // 排序
    // if (sortField.value) {
    //     filteredData = [...filteredData].sort((a, b) => {
    //         let valueA = a[sortField.value];
    //         let valueB = b[sortField.value];

    //         // 处理重要程度排序
    //         if (sortOrder.value === -1) {
    //             return valueA > valueB ? 1 : -1;
    //         } else {
    //             return valueA < valueB ? 1 : -1;
    //         }
    //     });
    // }
    return filteredData;
});

// 组件挂载时获取数据
onMounted(() => {
    fetchData();
});


// 导出处理的数据
const exportData = async (isMoring) => {
    processing.value = true // 显示处理中对话框
    try {
        // alert("call")
        // 调用后端接口获取文件链接
        var url = `${process.env.VUE_APP_BASE_URL}/api/llm/export/today`
        if (isMoring) {
            url = `${process.env.VUE_APP_BASE_URL}/api/llm/export/yesterday`
        }
        const response = await axios.get(url, {
            headers: {
            }
        })
        const fileUrl = process.env.VUE_APP_BASE_URL + response.data.file_url
        if (fileUrl) {
            // 创建临时链接并下载
            const link = document.createElement('a')
            link.href = fileUrl
            link.download = fileUrl.split('/').pop()// 可选：自定义文件名
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            ElMessage.warning("已经开始下载，请关注文件下载情况。")
        } else {
            ElMessage.error('未获取到下载链接')
        }
    } catch (error) {
        console.error(error)
        ElMessage.error('下载失败，请稍后重试')
    } finally {
        processing.value = false // 关闭处理框
    }
}

const confirmDownload = (isMoring) => {
    ElMessageBox.confirm(
        '是否确认下载数据文件？',
        '下载确认',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    ).then(async () => {
        await exportData(isMoring)
    }).catch(() => {
        ElMessage.warning('已取消下载')
    })
}
</script>

<template>
    <div class="dashboard">
        <!-- 处理中提示框 -->
        <el-dialog v-model="processing" title="处理中" width="300px" :close-on-click-modal="false" :show-close="false"
            align-center>
            <div style="text-align: center;">
                <el-icon class="is-loading" style="font-size: 28px; color: #409EFF;">
                    <Loading />
                </el-icon>
                <div style="margin-top: 10px;">文件正在处理，请稍候...</div>
            </div>
        </el-dialog>
        <div class="content">
            <h2>处理数据列表</h2>
            <!-- 搜索 & 排序 -->
            <div class="controls">
                <div class="controls-left">
                    <!-- 每页数据选择 -->
                    <label for="perPage">每页显示：</label>
                    <select id="perPage" v-model="itemsPerPage" @change="updateItemsPerPage">
                        <option v-for="option in perPageOptions" :key="option" :value="option">
                            {{ option }}
                        </option>
                    </select>
                </div>
                <div class="controls-left">
                    <label> 发布时间：</label>
                    <el-date-picker v-model="publishTimeRange" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" foramt="YYYY-MM-DD" value-format="YYYY-MM-DD"
                        @change="fetchData" :editable="false" :unlink-panels="true" :teleported="false"
                        style="width: 200px;" />
                    <label> 采集时间：</label>
                    <el-date-picker v-model="fetchTimeRange" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" foramt="YYYY-MM-DD" value-format="YYYY-MM-DD"
                        @change="fetchData" :editable="false" :unlink-panels="true" :teleported="false"
                        style="width: 200px;" />
                </div>
                <div class="controls-right">
                    <label for="searchQuery">标题或摘要：</label>
                    <input v-model="searchQuery" placeholder="支持模糊查询" />
                </div>
                <el-button type="primary" @click="fetchData">确认</el-button>
                <el-button icon="Download" type="normal" @click="confirmDownload(true)">导出上午数据</el-button>
                <el-button icon="Download" type="normal" @click="confirmDownload(false)">导出下午数据</el-button>
            </div>

            <!-- 数据表格 -->
            <div class="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>类型</th>
                            <th>标题</th>
                            <th>摘要</th>
                            <th @click="sortData('publishTime')">发布时间 {{ getSortIcon('publishTime') }}</th>
                            <th @click="sortData('runTime')">采集时间 {{ getSortIcon('runTime') }}</th>
                            <th @click="sortData('importance')">重要程度 {{ getSortIcon('importance') }}</th>
                            <th>国家地区</th>
                            <th>语言</th>
                            <th>来源</th>
                            <th>URL</th>
                            <!-- <th>操作</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in filteredAndSortedData" :key="item.id">
                            <td width="80px">{{ item.cate }}</td>
                            <td class="title" :title="item.title ? item.title : '- -'">
                                {{ item.title || '- -' }}
                            </td>
                            <td class="summary" :title="item.abstract">{{ item.abstract }}</td>
                            <td>{{ item.publishTime }}</td>
                            <td>{{ item.runTime }}</td>
                            <td>{{ item.importance }}</td>
                            <td>{{ item.country }}</td>
                            <td>{{ item.langName }}</td>
                            <td>{{ item.taskTitle }}</td>
                            <td><a :href="item.url" target="_blank">链接</a></td>
                            <!-- <td><button @click="viewDetails(item)">详细</button></td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- 翻页功能 -->
            <!-- <div class="pagination">
                <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">上一页</button>
                <span>第 {{ currentPage }} 页 / 共 {{ totalPages }} 页</span>
                <button @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages">下一页</button>
            </div> -->
            <div class="footer-container">
                <div class="total-items">总共: {{ totalItems }} 条数据</div>
                <div class="pagination-container">
                    <el-pagination v-model:current-page="currentPage" v-model:page-size="itemsPerPage"
                        :total="totalItems" layout="prev, pager, next, jumper" @current-change="fetchData"
                        @size-change="fetchData" />
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
/* 整体布局 */
.dashboard {
    display: flex;
    height: 100vh;
    background-color: #f4f7fa;
    margin: 0;
    /* 确保没有额外的边距 */
    padding: 0;
}

/* 侧边栏样式 */
.sidebar {
    width: 150px;
    background: #2c3e50;
    color: white;
    padding: 20px;
    transition: width 0.3s;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

/* 收起状态 */
.sidebar.collapsed {
    width: 30px;
    padding: 20px 10px;
}

/* 侧边栏按钮 */
.toggle-btn {
    background: none;
    border: none;
    color: white;
    font-size: 14px;
    cursor: pointer;
    margin-bottom: 10px;
}

/* 右侧内容区 */
.content {
    flex-grow: 1;
    padding: 20px;
}

.sidebar h2 {
    margin-bottom: 5px;
}

.sidebar ul {
    list-style: none;
    padding: 0;
}

.sidebar li {
    padding: 10px;
    cursor: pointer;
}

.sidebar li.active {
    background-color: #1abc9c;
}

/* 内容区域 */
.content {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    /* 🌟 关键代码：超出时可滚动 */
    max-height: 100vh;
    /* 避免内容撑出视口 */
}

/* 控制面板 */

.controls {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
}

.controls-left {
    display: flex;
    align-items: center;
}

.controls-left label {
    margin-right: 10px;
    font-size: 14px;
}

.controls-left select {
    padding: 6px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 14px;
}

.controls-right input {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 14px;
}

input {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

input,
select {
    padding: 5px;
    font-size: 14px;
    /* 控件字体变小 */
}

/* 表格 */
.table-container {
    max-height: calc(95vh - 150px);
    /* 计算高度，避免遮挡分页 */
    overflow-y: auto;
}

table {
    width: 100%;
    background: white;
    border-collapse: collapse;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    margin-top: 8px;
    font-size: 13px;
    /* 表格字体变小 */
}

th,
td {
    border: 1px solid #ddd;
    padding: 5px;
    /* height: 40px; */
    /* 调整单元格间距 */
}

th {
    background-color: #f4f4f4;
}

button {
    padding: 4px 8px;
    font-size: 13px;
    /* 按钮字体变小 */
    cursor: pointer;
}

.pagination {
    margin-top: 15px;
    font-size: 13px;
}

td.title,
td.summary {
    text-align: left;
    /* 左对齐 */
    max-width: 200px;
    /* 限制最大宽度 */
    white-space: nowrap;
    /* 强制单行显示 */
    overflow: hidden;
    /* 隐藏超出部分 */
    text-overflow: ellipsis;
    /* 省略号显示超出部分 */
    cursor: pointer;
    /* 鼠标悬停时显示可交互 */
    position: relative;
    /* 使 tooltip 定位正确 */
}

/* 悬停显示完整内容 */
td.title:hover::after,
td.summary:hover::after {
    content: attr(data-fulltext);
    /* 读取完整文本 */
    position: absolute;
    left: 0;
    bottom: 100%;
    background: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 5px;
    border-radius: 4px;
    font-size: 12px;
    white-space: normal;
    max-width: 300px;
    /* 控制 tooltip 最大宽度 */
    z-index: 10;
    word-wrap: break-word;
}

/* 按钮 */
.detail-btn {
    padding: 5px 10px;
    background: #3498db;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.detail-btn:hover {
    background: #2980b9;
}

/* 分页 */
.footer-container {
    display: flex;
    justify-content: space-between;
    /* 左右分布 */
    align-items: center;
    margin-top: 10px;
    padding: 0 20px;
}

.total-items {
    font-size: 14px;
    color: #666;
    text-align: left;
    /* 确保左对齐 */
}

.pagination {
    margin-top: 20px;
    text-align: center;
}

.pagination button {
    padding: 8px 12px;
    margin: 5px;
    border: none;
    border-radius: 5px;
    background: #3498db;
    color: white;
    cursor: pointer;
}

.pagination button:disabled {
    background: #95a5a6;
}

.pagination-container {
    display: flex;
    justify-content: flex-end;
    /* 让分页靠右 */
    margin-top: 10px;
    padding-right: 20px;
    /* 可调整右侧间距 */
}
</style>